import React from 'react';

const ToolbarContext = React.createContext({
    multirows: false,
    getShrinkedGroups: () => ({ groups: [], width: [], totalWidth: 0 }),
    dropdownRefs: new Map(),
});

export { ToolbarContext };
//# sourceMappingURL=toolbar-context.js.map
